// import axios from "axios";
// import CryptoJS from "crypto-js";
import { JsonResponseModel } from "../../Models/JsonResponseModel";
import { ApiStatus } from "../Enums/ApiStatus";
import { checkPermission } from "../PageAccess/CheckPermission";
import { getContext } from "../Context/Context";
import store from "../../Redux/store";
import { clearUserData, deleteUserData } from "../../Redux/Actions/index";
import { EncryptedRequestModel } from "../../Models/EncryptedRequestModel";
import { EncryptedResponseModel } from "../../Models/EncryptedResponseModel";
import { Decrypt, Encrypt } from "../Cryptography/Crypto";
import { fetchAuthToken } from "./OAuthHandler";
import { enableEncryption } from "../Constants/Constants";

// export function Encrypt(value: any) {
//   const encryptedString = CryptoJS.AES.encrypt(value, "REACTJS").toString();
//   return encryptedString;
// }

// export async function Decrypt(value: any) {
//   const decryptedWordArray = CryptoJS.AES.decrypt(value, "REACTJS");
//   const decryptedString = await decryptedWordArray.toString(CryptoJS.enc.Utf8);
//   return decryptedString;
// }

export enum HttpMethod {
  GET = "GET",
  POST = "POST",
}
const enableOAuthToken = true; //should change it to true after testing
export const APICall = async (
  apiUrl: string,
  inputParam: any,
  methodType: HttpMethod = HttpMethod.POST,
  shouldEnableEncryption: boolean = enableEncryption,
  userAuthToken: string = "",
  IsFormData: boolean = false // added
): Promise<JsonResponseModel> => {
  let responseBody: JsonResponseModel = {
    Status: ApiStatus.Error,
    Message: "",
    Data: null,
  };
  let ogResponseBody = responseBody;

  let pathName = window.location.pathname;
  const context = getContext();
  const permissionName = checkPermission(pathName);
  if (!IsFormData) {
    if (context && inputParam) {
      inputParam.userIdVAPT = context?.Id;
      inputParam.RoleIdVAPT = context?.loggedInAs?.value;
      inputParam.userIdForSession = context?.Id;
      inputParam.userLoggedInAsPermission = context?.loggedInAs?.value;
      inputParam.permissionName = permissionName;
    }

    // try {
    //   const inputParamCopy = inputParam;
    //   inputParam.encryptedRequestBody = Encrypt(JSON.stringify(inputParamCopy));
   
    //     `inputParam.encryptedRequestBody : ${inputParam.encryptedRequestBody}`
    //   );
    // } catch (err) {}
  } else {
    if (context && inputParam) {
      inputParam.append("userIdVAPT", context?.Id);
      inputParam.append("userIdForSession", context?.Id);
      inputParam.append("userLoggedInAsPermission", context?.loggedInAs?.value);
      inputParam.append("permissionName", permissionName);
    }

    // try {
    //   const inputParamCopy = inputParam;
    //   inputParam.append(
    //     "encryptedRequestBody",
    //     Encrypt(JSON.stringify(inputParamCopy))
    //   );
   
    //     `inputParam.encryptedRequestBody : ${inputParam.get(
    //       "encryptedRequestBody"
    //     )}`
    //   );
    // } catch (err) {}
  }

  try {
    let response: any;
    let bodyData: any;
    let headers = {};
    if (!IsFormData) {
      headers = {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        // Authorization: "Bearer " + userAuthToken,
      };
    }

    if (!inputParam) {
      delete headers["Content-Type"];
    }

    if (methodType === HttpMethod.POST && inputParam) {
      bodyData = inputParam ? JSON.stringify(inputParam) : null;
    }
    if (IsFormData && inputParam) {
      bodyData = inputParam;
    }

    //if (enableOAuthToken) {
    let token = await fetchAuthToken(false);
    headers["Authorization"] = `Bearer ${token}`;
    //}

    // if (inputParam?.encryptedRequestBody) {
    
    //     "inputParam.decryptedRequestBody : " +
    //       Decrypt(inputParam?.encryptedRequestBody)
    //   );
    // }
    if (shouldEnableEncryption && inputParam && !IsFormData) {
      let EncyptedRequestBody = Encrypt(JSON.stringify(inputParam));

      bodyData = JSON.stringify({
        RequestBody: EncyptedRequestBody,
      } as EncryptedRequestModel);
    }

    response = await fetch(apiUrl, {
      method: methodType.toString(),
      headers: headers,
      body: bodyData,
    });

    if (enableOAuthToken && response.status === 401) {
      let token = await fetchAuthToken(true);
      headers["Authorization"] = `Bearer ${token}`;

      response = await fetch(apiUrl, {
        method: methodType.toString(),
        headers: headers,
        body: bodyData,
      });
    }

    if (response.status === 403) {
      // eslint-disable-next-line no-restricted-globals
      if (confirm("Session expired, please login again")) {
        // deleteLocalStorage();
        store.dispatch(clearUserData(null));
        window.location.href = `${window.location.origin}/login`;
      }
    }

    if (response.status === 405) {
      // eslint-disable-next-line no-restricted-globals
      if (confirm("Something went wrong . Please Contact Administrator")) {
        // store.dispatch(clearUserData(null));
        // window.location.href = `${window.location.origin}/login`;
        return;
      }
    }


    if (shouldEnableEncryption) {
      responseBody = await response.json();
      let newResponseBody = responseBody as EncryptedResponseModel;
      let DecyptedRequestBody = Decrypt(newResponseBody.Data);
      if (DecyptedRequestBody) {
        responseBody = JSON.parse(DecyptedRequestBody) as JsonResponseModel;
      } else {
        responseBody = ogResponseBody;
      }
    } else {
      responseBody = (await response.json()) as JsonResponseModel;
    }
    
    // if (response.data?.message === "Unauthorized") {
    //   // eslint-disable-next-line no-restricted-globals
    //   if (confirm("Session expired, please login again")) {
    //     store.dispatch(deleteUserData());
    //     window.location.replace(`${window.location.origin}/login`);
    //   }
    // }
  } catch (error) {
    if ((await error?.response?.data?.message) === "Unauthorized") {
      // eslint-disable-next-line no-restricted-globals
      if (confirm("Session expired, please login again")) {
        store.dispatch(deleteUserData());
        window.location.replace(`${window.location.origin}/login`);
      }
    }

    responseBody.Message = error?.message;
    responseBody.Data = JSON.parse(JSON.stringify(error));
  }

  return responseBody;
};

// import CryptoJS from "crypto-js";
// import { JsonResponseModel } from "../Models/JsonResponseModel";
// import { ApiStatus } from "./Enums/ApiStatus";

// export function Encrypt(value: any) {
//   const encryptedString = CryptoJS.AES.encrypt(value, "REACTJS").toString();
//   return encryptedString;
// }

// export async function Decrypt(value: any) {
//   const decryptedWordArray = CryptoJS.AES.decrypt(value, "REACTJS");
//   const decryptedString = await decryptedWordArray.toString(CryptoJS.enc.Utf8);
//   return decryptedString;
// }

// export enum HttpMethod {
//   GET = "GET",
//   POST = "POST",
// }

// export const APICall = async (
//   apiUrl: string,
//   inputParam: Object | Array<Object>,
//   methodType: HttpMethod = HttpMethod.POST,
//   enableEncryption: boolean = true,
//   userAuthToken: string = ""
// ): Promise<JsonResponseModel> => {
//   let responseBody: JsonResponseModel = {
//     Status: ApiStatus.Error,
//     Message: "",
//     Data: null,
//   };
//   if (enableEncryption) {
//     try {
//       let response;
//       if(methodType === HttpMethod.POST){
//         response = await fetch(apiUrl, {
//           method: methodType.toString(),
//           headers: {
//             "Access-Control-Allow-Origin": "*",
//             "Content-Type": "application/json",
//             "Access-Control-Allow-Headers": "*",
//             // Authorization: "Bearer " + userAuthToken,
//           },
//      body : JSON.stringify(inputParam),

//         });
//       }
//       else {
//         response = await fetch(apiUrl, {
//           method: methodType.toString(),
//           headers: {
//             "Access-Control-Allow-Origin": "*",
//             "Content-Type": "application/json",
//             "Access-Control-Allow-Headers": "*",
//             // Authorization: "Bearer " + userAuthToken,
//           },

//         });
//       }

//       responseBody = (await response.json()) as JsonResponseModel;
//     }

//     catch (error) {
//       responseBody.Message = error?.message;
//       responseBody.Data = JSON.parse(JSON.stringify(error));
//     }
//   }
//   return responseBody;
// };
